import React from 'react';
import { SessionExpiredErrorDialog } from './SessionExpiredErrorDialog';
import { useNewBookingStore } from '../../domain/booking/stores/useNewBookingsStore';
import { useNavigate } from '../../../shared/router/useNavigate';

interface ISessionExpiredErrorProps {
	sessionExpiredNextUrl: string;
}

export const SessionExpiredError = ({
	sessionExpiredNextUrl,
}: ISessionExpiredErrorProps) => {
	const navigate = useNavigate();
	const { parkingProductsQuoteStore } = useNewBookingStore();

	const handleClose = () => {
		parkingProductsQuoteStore.reset();
		navigate(sessionExpiredNextUrl);
	};

	return <SessionExpiredErrorDialog onClose={handleClose} />;
};
